module.exports = __webpack_public_path__ + "img/pic_tltw_lxfsy_normal@2x.a14e4d76.png";